module.exports = __webpack_public_path__ + "img/Réalisation d_un portail en pente..ecd61a51.jpg";